import PartnersView from './PartnersView'

export default PartnersView
